export default "__VITE_ASSET__V5bd7jHe__"